import { Account } from '@/api/generated/model';
import { AccountForm } from '@/components/accounts/AccountForm';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useLanguage } from '@/i18n/LanguageContext';

interface AccountDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: (data: {
    name?: string;
    type?: 'bank' | 'investment' | 'real-estate' | 'crypto' | 'alternative' | 'liability';
    balance?: number;
    institution?: string;
  }) => Promise<void>;
  onCancel: () => void;
  initialData?: Account | null;
  mode: 'add' | 'edit';
}

export function AccountDialog({
  open,
  onOpenChange,
  onSubmit,
  onCancel,
  initialData,
  mode,
}: AccountDialogProps) {
  const { t } = useLanguage();
  const isEditMode = mode === 'edit';

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {isEditMode ? t('accounts.edit.title') : t('accounts.add.title')}
          </DialogTitle>
          <DialogDescription>
            {isEditMode ? t('accounts.edit.description') : t('accounts.add.description')}
          </DialogDescription>
        </DialogHeader>
        <AccountForm initialData={initialData} onSubmit={onSubmit} onCancel={onCancel} />
      </DialogContent>
    </Dialog>
  );
}
